import { Component, OnInit, TemplateRef } from '@angular/core';
import { SessionService } from '../../../services/session.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProductoPrecioModalComponent } from '../../modals/producto-precio-modal/producto-precio-modal.component';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { ParametroService } from '../../../services/parametro.service';
import * as moment from 'moment';
import { Parametro } from '../../../models/parametro';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { UtilsService } from '../../../services/utils.service';
import { ProformaModalComponent } from '../../modals/proforma-modal/proforma-modal.component';
import { ProductoService } from '../../../services/producto.service';
import { ServicioModalComponent } from '../../modals/servicio-modal/servicio-modal.component';
import { OrdenCompra } from '../../../models/orden-compra';
import { OrdenCompraDetalle } from '../../../models/orden-compra-detalle';
import { OrdenCompraService } from '../../../services/orden-compra.service';
import { Proveedor } from '../../../models/proveedor';
import { ProveedorModalComponent } from '../../modals/proveedor-modal/proveedor-modal.component';

import { ProveedorService } from '../../../services/proveedor.service';
import { BodegaService } from '../../../services/bodega.service';
import { Bodega } from '../../../models/bodega';
import { OrdenCompraAddModalComponent } from '../../modals/orden-compra-add-modal/orden-compra-add-modal.component';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';

@Component({
  selector: 'app-orden-compra-add',
  templateUrl: './orden-compra-add.component.html',
  styleUrls: ['./orden-compra-add.component.css'],
  providers: [
    BodegaService,
    ProveedorService,
    BsModalService,
    ParametroService,
    OrdenCompraService,
    ProductoService,
    ImpuestoPorcentajeService
  ]
})
export class OrdenCompraAddComponent implements OnInit {
  public loading = false;
  public orden: OrdenCompra;
  public bodegas: Array<Bodega>;
  public detalle: String;
  public orden_detalle: OrdenCompraDetalle;
  public ordenesDetalle: Array<OrdenCompraDetalle>;
  public param: Parametro;
  public proveedor: Proveedor;
  public bsModalRef: BsModalRef;
  public msgSweet: SweetMessage;
  public vl: Validation;
  public IVA: number;
  public SECUENCIAL: number;
  public fecha_emision;
  public fecha_caducidad;
  public isPrinted: boolean;
  public isMail: boolean;
  public ordenIdPrinted: String;
  public cotizacion: string;
  public Mod_Inventario: string;
  public observacion: String;
  public Mod_FactElec: string;
  public fecha_actual;
  public fecha_MesAnt;
  public numero_decimales: number;
  public format_decimal: String;
  public is_reingreso:boolean;
  public iva_vigente: boolean;
  public iva_id: number;
  public parametros:Array<any>;
  public iva_porcentaje : any;


  constructor(
    public ss: SessionService,
    public bodegaService: BodegaService,
    public proveedorService: ProveedorService,
    public modalService: BsModalService,
    public parametroService: ParametroService,
    public ordenService: OrdenCompraService,
    public utils: UtilsService,
    public productoService: ProductoService,
    public impuestoPorcentajeService: ImpuestoPorcentajeService
  ) {
    this.orden = new OrdenCompra();
    this.ordenesDetalle = [];
    this.bodegas = [];
    this.param = new Parametro();
    this.proveedor = new Proveedor();
    this.msgSweet = new SweetMessage();
    this.vl = new Validation();
    this.IVA = 0;
    this.isMail = false;
    this.isPrinted = false;
    this.SECUENCIAL = 0;
    this.fecha_emision = moment(this.fecha_emision);
    this.fecha_caducidad = moment(this.fecha_caducidad);
    this.fecha_actual = moment(this.fecha_actual);
    this.fecha_MesAnt = moment(this.fecha_actual.subtract(1, 'months'));
    this.Mod_Inventario = this.ss.getData("mod_inventario");
    this.observacion = "";
    this.Mod_FactElec = this.ss.getData("mod_felectronica");
    this.numero_decimales = 2;
    this.format_decimal = "0,0.00";
    this.detalle = "";
    this.orden_detalle = new OrdenCompraDetalle();
    this.is_reingreso = false;
    this.iva_vigente= false;
    this.iva_id = 0;
    this.parametros = [];
    this.iva_porcentaje = 0;
  }

  ngOnInit() {
    let p1 = this.getBodegas();
    let p2 = this.getParametros();
    let p3 = this.getSecuencial();
    let p4 = this.getParamNumeroDecimales();
    let p5 = this.getBodegaBySucursal();
    let p6 = this.getIVA(129);

    this.loading = true;
    Promise.all([p1, p2, p3, p4, p5,p6]).then(
      res => this.loading = false,
      err => this.loading = false
    );
  }

  onSubmit() {
    this.msgSweet.showMessage('delete-confirm-message', "¿Está seguro de confirmar la orden?").then(
      res => {
        this.setValueEntity();
        this.loading = true;
        this.ordenService.save(this.orden).subscribe(
          res => {
            this.loading = false;
            this.isPrinted = true;
            this.isMail = true;
            this.ordenIdPrinted = res.id;
            this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente ');
            let bodega_id = this.orden.bodega_id;
            this.orden = new OrdenCompra();
            this.orden.bodega_id = bodega_id;
            this.observacion = "";
            this.proveedor = new Proveedor();
            this.ordenesDetalle = [];
            this.getBodegas();
            this.getSecuencial();
          },
          err => {
            this.loading = false;
            this.msgSweet.showMessage('error-message', err);
          }
        );
      }
    );
  }

  setValueEntity() {
    this.orden.secuencial = this.SECUENCIAL;
    this.orden.proveedor_id = this.proveedor.id;
    this.orden.observacion = this.observacion.toString().trim();
    this.orden.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD");
    this.orden.fecha_caducidad = moment(this.fecha_caducidad).format("YYYY-MM-DD");
    this.orden.usuario_id = this.ss.getData('usuario_id');
    this.orden.empresa_id = this.ss.getData('empresa_id');
    this.orden.sucursal_id = this.ss.getData('sucursal_id');

    this.ordenesDetalle.forEach(detalle => {
      detalle.iva = detalle.subtotal * this.IVA;
      detalle.total = detalle.subtotal + detalle.iva;
    });

    this.orden.detalle = this.ordenesDetalle;
  }

  getBodegas() {
    return new Promise((resolve, reject) => {
      this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
        res => {
          if (!res.data.length) {
            this.bodegas = [];
          } else {
            this.bodegas = res.data;
          }
          resolve();
        },
        err => {
          this.bodegas = [];
          reject(err);
        }
      );
    });
  }

  getBodegaBySucursal() {
    return new Promise((resolve, reject) => {
      if (!this.Mod_Inventario) {
        this.orden.bodega_id = "1"; // BODEGA POR DEFECTO / SUCURSAL 1
        resolve();
      } else {
        this.bodegaService.getAll("?sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
          res => {
            this.orden.bodega_id = res.data[0].id;
            resolve();
          },
          err => {
            this.orden.bodega_id = "";
            reject()
          }
        );
      }
    });
  }



  getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
					this.IVA = parseFloat(this.iva_porcentaje) / 100;
					this.calcularFactura();
					resolve();
				},
				err => {
					this.iva_porcentaje = 0;
					this.IVA = 0;
					reject(err);
				}
			);

			
		});
	}

  getParametros() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve();
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

  getSecuencial() {
    return new Promise((resolve, reject) => {
      this.parametroService.getById(23).subscribe(
        res => {
          this.param = res[0];
          this.SECUENCIAL = parseInt(res.valor);
          resolve();
        },
        err => {
          this.SECUENCIAL = 0;
          reject(err);
        }
      );
    });
  }

  getParamNumeroDecimales() {
    return new Promise((resolve, reject) => {
      let numero_decimales = 19;
      this.parametroService.getById(numero_decimales).subscribe(
        res => {
          this.numero_decimales = res.valor;

          let digitos = "";
          for (let i = 0; i < this.numero_decimales; i++) digitos += "0";
          this.format_decimal = "0,0." + digitos
          resolve();
        },
        err => {
          this.numero_decimales = 2;
          this.format_decimal = "0,0.00"
          reject(err);
        }
      );
    });
  }

  get formatDecimal() {
    return this.format_decimal;
  }

  onSearchProveedor(event) {
    if (event.keyCode === 13) {
      if (this.proveedor.dni.toString().trim().length == 0) {
        this.isPrinted = false;
        this.proveedor = new Proveedor();
        return;
      } else {
        this.loading = true;
        this.proveedorService.getByDni(this.proveedor.dni).subscribe(
          res => {
            this.loading = false;
            this.isPrinted = false;
            if (res.length > 0) {
              this.proveedor = res[0];
            } else {
              this.proveedor = new Proveedor();
              this.openDialogProveedor();
            }
          },
          err => {
            this.loading = false;
            this.openDialogProveedor();
          }
        );
      }
    }
  }

  openDialogProveedor() {
    this.isPrinted = false;
    const initialState = {};
    this.bsModalRef = this.modalService.show(ProveedorModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));
    this.bsModalRef.content.sendProveedor.take(1).subscribe(proveedor => this.proveedor = proveedor);
  }

  onSearchProducto() {
    if (!this.orden.bodega_id) {
      this.msgSweet.showMessage('error-message', "Seleccione la bodega");
      return;
    }
    const initialState = { bodega_id: this.orden.bodega_id, numero_decimales: this.numero_decimales, es_comprado: 1, tipo_producto_id: '1' };
    this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

    this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
      // value.precio = 0;
      let incluye_precio = false;
      this.sendObjectProducto(value,incluye_precio)
    });
  }
  onSearchConsumible() {

		const initialState = { bodega_id: this.orden.bodega_id, numero_decimales: this.numero_decimales, es_comprado: 1, tipo_producto_id: '3' };
		this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {

			// value.precio = 0;
			let incluye_precio = false;
			// this.impuesto_id= value.impuesto_iva_id;
			this.sendObjectProducto(value,incluye_precio);
			// if (this.impuesto_id != 0) {
			// 	this.getImpuestoPorcentaje(this.impuesto_id);
			// }
		});


	}

  onSearchServicio() {
    const initialState = { numero_decimales: this.numero_decimales, es_comprado: 1};
    this.bsModalRef = this.modalService.show(ServicioModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

    this.bsModalRef.content.sendProductoPrecio.subscribe((value) => {
      let item = { ...value };
      //item = {...value};
      // item['precio']= 0;
      item['unidadmedida'] = {};
      item['unidadmedida']['nombre'] = value.unidad;
      item['codigo'] = value.codigo;
      item['nombre'] = value.nombre;
      item['id'] = value.id;
      // item['es_servicio'] = value.es_servicio;
      item['tipo_producto_id'] = value.tipo_producto_id;

      item['producto'] = value.es_servicio;
      let incluye_precio = false;
      this.sendObjectProducto(item,incluye_precio);
    });
  }


  sendObjectProducto(producto: any,incluye_precio) {
    let temp = this.ordenesDetalle.find(orden => orden.producto_id == producto.id);

    //if (!temp) {
    let orden_detalle = new OrdenCompraDetalle();
    orden_detalle.cantidad_stock = producto.cantidad_stock;
    orden_detalle.cantidad = (producto.cantidad?producto.cantidad:1);
    // orden_detalle.es_servicio = producto.es_servicio;
    orden_detalle.tipo_producto_id = producto.tipo_producto_id;
    orden_detalle.descripcion = producto.descripcion;
    orden_detalle.producto = producto.nombre;
    orden_detalle.codigo = producto.codigo;
    orden_detalle.unidad = producto.unidad;
    orden_detalle.producto_id = producto.id;
    orden_detalle.graba_iva = producto.graba_iva;
    // orden_detalle.precio_unitario = (producto.precio?producto.precio:0);
    (incluye_precio)?orden_detalle.precio_unitario = producto.precio:orden_detalle.precio_unitario = 0;

    orden_detalle.subtotal = orden_detalle.cantidad * orden_detalle.precio_unitario;
    orden_detalle.iva = orden_detalle.subtotal * this.IVA;
    orden_detalle.total = orden_detalle.subtotal + orden_detalle.iva;

    orden_detalle.usuario_id = this.ss.getData('usuario_id');
    orden_detalle.empresa_id = this.ss.getData('empresa_id');
    orden_detalle.sucursal_id = this.ss.getData('sucursal_id');

    this.ordenesDetalle.push(orden_detalle);
    this.calcularFactura();
    //}
  }

  calcularFactura() {
    this.orden.subtotal_iva12 = 0;
    this.orden.subtotal_iva0 = 0;
    this.orden.iva = 0;
    this.orden.total = 0;

    this.ordenesDetalle.forEach(obj => {
      if (obj.graba_iva) {
        this.orden.subtotal_iva12 += obj.subtotal;
      } else {
        this.orden.subtotal_iva0 += obj.subtotal;
      }
    });
    if (this.orden.desct_valor.toString().trim().length === 0) {
			this.orden.desct_valor = 0;
		}
    this.orden.subtotal = parseFloat(this.orden.subtotal_iva0.toString()) + parseFloat(this.orden.subtotal_iva12.toString());
		this.orden.subtotal = parseFloat(this.orden.subtotal.toString()) - parseFloat(this.orden.desct_valor.toString());

		this.orden.subtotal = this.utils.redondear(this.orden.subtotal, this.numero_decimales);

	
		this.orden.iva = this.utils.redondear(((this.orden.subtotal_iva12 - this.orden.desct_valor) * this.IVA), this.numero_decimales);

		this.orden.total = this.orden.subtotal + this.orden.iva;
		this.orden.total = this.utils.redondear(this.orden.total, this.numero_decimales);

  }

  isValidForm() {

    if (!this.vl.validDate(this.fecha_emision.toString())) {
      return false;
    }
    if (!this.vl.validDate(this.fecha_caducidad.toString())) {
      return false;
    }
    if (!this.orden.bodega_id) {
      return false;
    }
    if (!this.proveedor.dni) {
      return false;
    }
    if (!this.ordenesDetalle.length) {
      return false;
    }
    if (this.fecha_emision < this.fecha_MesAnt) {
      return false;
    }
    return true;
  }

  onPrint() {
    let params = [];
    params["usuario_id"] = this.ss.getData('usuario_id');
    let qs = [];
    if (this.orden.bodega_id) {
        params["bodega_id"] = this.orden.bodega_id;
    }
    for (let key in params) {
      let str = key + "=" + params[key];
      qs.push(str);
    }
    const initialState = { route: "orden-compra/" + this.ordenIdPrinted, qs: "?" + qs.join("&") + "&dbname=" + this.ss.getData('dbname') };
    this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));
  }

  changeValue(event, orden_detalle: OrdenCompraDetalle, campo: string) {
    let dscto_valor = orden_detalle.desc_valor;
    let dscto_porcent = orden_detalle.desc_porcent;
    let value = event.target.value;

    orden_detalle[campo] = value;

    if (campo === 'desc_porcent') {
      if (orden_detalle[campo] > 100) {
        orden_detalle[campo] = 100;
      }
    }
    let subtotal = (orden_detalle.cantidad * orden_detalle.precio_unitario) - orden_detalle.desc_valor;
    let porcent_value = subtotal * (orden_detalle.desc_porcent / 100)
    orden_detalle.subtotal = subtotal - porcent_value;

    this.calcularFactura();
  }

  verificationValue(event, orden_detalle: OrdenCompraDetalle, campo: string) {
    if (event.target.value.trim().length === 0) {
      if (campo === 'cantidad') {
        orden_detalle[campo] = 1;
      } else {
        orden_detalle[campo] = 0;
      }
    }
  }

  onDelete(i) {
    this.ordenesDetalle.splice(i, 1);
    this.calcularFactura();
  }

  onChangeFecha(event) {
    if (event < this.fecha_MesAnt) {
      this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores al mes");
    }
  }

  openModalDetalle(template: TemplateRef<any>, orden_detalle: OrdenCompraDetalle) {
		this.detalle = orden_detalle.detalle;
		this.orden_detalle = orden_detalle;
		this.bsModalRef = this.modalService.show(template);
  }
  
  saveDetalle() {
		this.orden_detalle.detalle = this.detalle.toString().trim();
		this.detalle = "";
		this.bsModalRef.hide();
	}

  onSearchOrden() {
    const initialState = { numero_decimales: this.numero_decimales };
    this.bsModalRef = this.modalService.show(OrdenCompraAddModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

    this.bsModalRef.content.sendOrden.take(1).subscribe((value) => {

      this.ordenesDetalle = [];
      this.loading = true;
      this.is_reingreso =true;
      this.getOrden(value.id).then(
        res => this.loading = false,
        err => this.loading = false,
      );
    });
  }

  getOrden($id) {
    let arrayPromise = [];
    return new Promise((resolve, reject) => {
      this.ordenService.getById($id, "?embed=detalle,proveedor?embed=tipoidentificacion").subscribe(
        res => {
          this.orden = res.data;
        
          this.observacion = this.orden.observacion;
          this.fecha_emision = moment(this.orden.fecha_emision);
          this.fecha_caducidad = moment(this.orden.fecha_caducidad);
          this.proveedor = this.orden.proveedor;
          // this.SECUENCIAL = this.orden.secuencial; 

          this.orden.detalle.forEach(item => {
            let producto: any = {};
            arrayPromise.push(new Promise((resolve, reject) => {
              this.productoService.getWithPrice(this.orden.bodega_id, '?page=1&per_page=10&producto_id=' + item.producto_id).subscribe(
                res => {
                  if (res.data.length) {
                    let data1 = res.data[0];

                    producto['cantidad_stock'] = data1.cantidad_stock;
                    producto['cantidad'] = item.cantidad;
                    // producto['es_servicio'] = data1.cantidad_stock;
                    producto['tipo_producto_id'] = data1.tipo_producto_id;
                    producto['descripcion'] = data1.descripcion;;
                    producto['nombre'] = data1.nombre;
                    producto['codigo'] = data1.codigo;;
                    producto['unidad'] = data1.unidad;
                    producto['id'] = data1.id;
                    producto['graba_iva'] = data1.graba_iva;
                    producto['precio'] = parseFloat((item.subtotal/item.cantidad).toString());
                    // this.utils.redondear(producto.precio, this.numero_decimales);
                    let incluye_precio = true;
                    this.sendObjectProducto(producto,incluye_precio);
                  }
                  else {
                    this.msgSweet.showMessage('error-message', "El producto no tiene stock suficiente");
                  }

                  resolve();
                },
                err => {
                  reject(err);
                }
              );
            }));
          });

          Promise.all(arrayPromise).then(
            res => resolve(),
            err => reject(err)
          );
        },
        err => {
          this.orden = new OrdenCompra;
          reject(err);
        }
      );
    });
  }


}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/orden-compra-add/orden-compra-add.component.ts